import { Icon } from '@/components/ui/Icon'
import { cn } from '@/lib/cn'

type SpinnerProps = {
  label?: string
  className?: string
}

export function Spinner({ label = 'Loading', className }: SpinnerProps) {
  return (
    <span role="status" className="inline-flex items-center">
      <Icon name="spinner" className={cn('animate-spin', className)} />
      <span className="sr-only">{label}</span>
    </span>
  )
}
